import Vue from 'vue'
import App from '@/App.vue'
import vuetify from '@/plugins/vuetify'
import store from '@/vuex/index'
import router from '@/router'
import 'babel-polyfill'
import interceptorsSetup from '@/helpers/interceptors'

Vue.config.productionTip = false

// loading overlay
import VueLoading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

// confirm
import VuetifyConfirm from 'vuetify-confirm'

// vee-validate
import VeeValidate from 'vee-validate'

// vue-clipboard
import VueClipboard from 'vue-clipboard2'

// vue orientation changer
import VueImgOrientationChanger from 'vue-img-orientation-changer'

// material
import VueMaterialIcon from 'vue-material-icon'

import VuePreviewer from 'vue-image-previewer'
Vue.use(VuePreviewer);

// custom css
import '@/assets/css/style.css'
import '@/assets/css/loader.css'

Vue.component(VueMaterialIcon.name, VueMaterialIcon)
Vue.component('loading', VueLoading)
Vue.use(VueImgOrientationChanger)
Vue.use(VueClipboard)
Vue.use(require('vue-moment'))
Vue.use(VuetifyConfirm, {
  vuetify,
  buttonTrueText: 'Yes',
  buttonFalseText: 'No',
  property: '$confirm'
})
Vue.use(VeeValidate)

interceptorsSetup()

Vue.config.productionTip = false

new Vue({
  vuetify,
  store,
  router,
  render: h => h(App)
}).$mount('#app')
